import type { CellKey } from "./types";

export function createCellKey(hour: number, day: number): CellKey {
  return `${hour}-${day}`;
}

export function parseCellKey(key: CellKey): [hour: number, day: number] {
  const parts = key.split("-");
  return [Number(parts[0]), Number(parts[1])];
}
